import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class FieldReportService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure';
  protected manureSpaceBaseUrl = this.env.API_BASE_URL + '/service/arable-service';

  public downloadAdviceReport(year: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/fieldreport/export/${year}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  public downloadManureSpaceReport(year: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.manureSpaceBaseUrl}/manurespacereport/export/${year}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
